import script from "./novoProjeto.vue?vue&type=script&setup=true&lang=js"
export * from "./novoProjeto.vue?vue&type=script&setup=true&lang=js"

import "./novoProjeto.vue?vue&type=style&index=0&id=2b3205fb&lang=css"

const __exports__ = script;

export default __exports__